<div class="dialog-content-wrapper m-0">
  <dialog-header headerClass="primary" 
                 title="{{'CANCELCONFIRM.TITLE' | translate}}">
  </dialog-header>
  
  <div class="pt-8 px-16">
    <p>{{'CANCELCONFIRM.MESSAGE' | translate}}</p>
    <div *ngFor="let order of orders">
      <p>{{'CANCELCONFIRM.ORDERNUMBER' | translate}} {{order.number()}}</p>
    </div>
    <div class="py-8" fxLayout="row" fxLayoutAlign="end center">
      <button mat-raised-button
              color="warn"
              (click)="execute()"
              [disabled]="isExecuting()"
              cdkFocusInitial>{{'CANCELCONFIRM.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</div>
